import { useToast } from "@/components/ui/use-toast";
import {
  CapacitorBarcodeScanner,
  CapacitorBarcodeScannerScanOrientation,
  CapacitorBarcodeScannerTypeHint,
} from "@capacitor/barcode-scanner";
import { useCallback } from "react";

export function useScanBarcode() {
  const { toast } = useToast();

  return useCallback(async () => {
    try {
      const barcodeResponse = await CapacitorBarcodeScanner.scanBarcode({
        hint: CapacitorBarcodeScannerTypeHint.PDF_417,
        scanOrientation: CapacitorBarcodeScannerScanOrientation.ADAPTIVE,
        web: {
          scannerFPS: 60,
          showCameraSelection: true,
        },
      });

      if (!barcodeResponse.ScanResult) {
        toast({
          title: "Kein Scanergebnis gefunden",
          variant: "error",
        });

        throw new Error("No scan result found");
      }

      return barcodeResponse.ScanResult;
    } catch (error) {
      console.error("Error scanning barcode:", error);
      throw error;
    }
  }, [toast]);
}
